import { createSvgIcon } from '../../createSvgIcon';
import { CHEVRON_PATH_D } from '../chevronPath';

export const ChevronLeftIcon = createSvgIcon(
  <path d={CHEVRON_PATH_D} fill="currentColor" transform="translate(15, 0) scale(-1, 1)" />,
  { displayName: 'ChevronLeftIcon', viewBox: '0 0 15 27' }
);
